var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      _vm.$emit("update:inputData", _vm.inputData)
                      _vm.$emit("input", 2)
                    },
                  },
                },
                [
                  _c("b-icon", { attrs: { icon: "arrow90deg-left" } }),
                  _vm._v(" Ödev Listesine Dön "),
                ],
                1
              ),
              [
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "360px" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "b-button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ml-2",
                                    attrs: { size: "sm", variant: "primary" },
                                  },
                                  "b-button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_vm._v(" Kazanımlar ")]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.dialog,
                      callback: function ($$v) {
                        _vm.dialog = $$v
                      },
                      expression: "dialog",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", { staticClass: "text-h5" }, [
                          _vm._v(" Kazanımlar"),
                        ]),
                        _c(
                          "v-card-text",
                          _vm._l(
                            _vm.sourceTest.Achievements2,
                            function (i, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _vm._v(" " + _vm._s(i.LessonUnitName) + " "),
                                  _c("br"),
                                  _vm._v(" " + _vm._s(i.ParentSubjectName)),
                                  _c("br"),
                                  _vm._v(" " + _vm._s(i.ChildSubjectName)),
                                  _c("br"),
                                  _vm._v(" " + _vm._s(i.ParentAchievementName)),
                                  _c("br"),
                                  _vm._v(" " + _vm._s(i.ChildAchievementName)),
                                  _c("br"),
                                  _c("v-divider"),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              _vm.sourceTest &&
              _vm.sourceTest.FileKey != null &&
              !_vm.$vuetify.breakpoint.mobile
                ? _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        size: "sm",
                        variant: _vm.hidePdf ? "success" : "danger",
                      },
                      on: {
                        click: function ($event) {
                          _vm.hidePdf = !_vm.hidePdf
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.hidePdf ? "PDF'i Göster" : "PDF'i Gizle") +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _vm.sourceTest && _vm.sourceTest.FileKey != null && !_vm.hidePdf
                ? _c(
                    "v-col",
                    { staticClass: "text-center" },
                    [
                      !_vm.$vuetify.breakpoint.mobile
                        ? _c("iframe", {
                            staticStyle: { border: "none" },
                            attrs: {
                              src: _vm.sourceTest.FilePublicUrl,
                              width: "100%",
                              height: _vm.$vuetify.breakpoint.mobile
                                ? "400"
                                : "800",
                            },
                          })
                        : _c(
                            "b-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.openLink(
                                    _vm.sourceTest.FilePublicUrl
                                  )
                                },
                              },
                            },
                            [_vm._v("Ödev PDF'ini görüntüle")]
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "p-10",
                      attrs: { outlined: "", rounded: "" },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("h6", [
                                _vm._v(
                                  "Son Kontrol Tarihi: " +
                                    _vm._s(_vm._f("momentDate")(_vm.endDate)) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("h6", [
                                _vm._v(_vm._s(_vm.sourceTest.SourceName)),
                              ]),
                              _c("h6", { staticClass: "font-weight-normal" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.sourceTest.SourceChapterName) +
                                    " - " +
                                    _vm._s(_vm.sourceTest.Name) +
                                    " "
                                ),
                              ]),
                              _c("v-spacer"),
                              _c(
                                "v-alert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isLocked,
                                      expression: "isLocked",
                                    },
                                  ],
                                  attrs: { type: "warning", color: "orange" },
                                },
                                [
                                  _vm._v(
                                    " Ödev kontrol tarihi geçtiği için öğretmenimiz, soruların cevaplarının işaretlenmesini kapatmıştır. Ödevinizi tamamladıysanız, lütfen öğretmenimizle iletişime geçiniz. "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.homeworkAnswers, function (item, index) {
                        return _c("div", { key: index }, [
                          _c(
                            "div",
                            {
                              staticClass: "m-3 d-flex justify-content-center",
                            },
                            [
                              _c("div", { staticClass: "text-center m-2" }, [
                                _vm._v(
                                  _vm._s(item.QuestionNumber.toString()) + ")"
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        size: "md",
                                        name: "radio-btn-outline",
                                        buttons: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.saveTestAnswerToList(item)
                                        },
                                      },
                                      model: {
                                        value: item.TestOptionTypeId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "TestOptionTypeId",
                                            $$v
                                          )
                                        },
                                        expression: "item.TestOptionTypeId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.testOptionTypes,
                                      function (option) {
                                        return _c(
                                          "b-form-radio",
                                          {
                                            key: option.Id,
                                            attrs: {
                                              value: option.Id,
                                              name: option.Name,
                                              disabled:
                                                option.Id !=
                                                item.TestOptionTypeId
                                                  ? option.disabled
                                                  : false,
                                              "button-variant": item.color
                                                ? item.color
                                                : "outline-primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(option.Name) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      }),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex justify-content-center m-2",
                            },
                            [
                              _vm.correctCount === 0 && _vm.wrongCount === 0
                                ? _c(
                                    "b-progress",
                                    {
                                      staticStyle: { "min-width": "250px" },
                                      attrs: {
                                        max: _vm.progressMax,
                                        variant: "primary",
                                        "show-progress": "",
                                      },
                                    },
                                    [
                                      _c("b-progress-bar", {
                                        attrs: {
                                          value: _vm.answeredQuestionCount,
                                          label: `${(
                                            (_vm.answeredQuestionCount /
                                              _vm.progressMax) *
                                            100
                                          ).toFixed(0)}%`,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-progress",
                                    {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover",
                                          value:
                                            _vm.correctCount +
                                            " D / " +
                                            _vm.wrongCount +
                                            " Y / " +
                                            _vm.emptyCount +
                                            " B",
                                          expression:
                                            "correctCount + ' D / ' + wrongCount + ' Y / ' + emptyCount + ' B'",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticStyle: { "min-width": "250px" },
                                      attrs: {
                                        max: _vm.progressMax,
                                        "show-value": "",
                                      },
                                    },
                                    [
                                      _c("b-progress-bar", {
                                        attrs: {
                                          value: _vm.correctCount,
                                          variant: "success",
                                        },
                                      }),
                                      _c("b-progress-bar", {
                                        attrs: {
                                          value: _vm.wrongCount,
                                          variant: "danger",
                                        },
                                      }),
                                      _c("b-progress-bar", {
                                        attrs: {
                                          value: _vm.emptyCount,
                                          variant: "secondary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      !_vm.isLocked
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.saveTestAnswersBulk },
                                    },
                                    [_vm._v("KAYDET")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }